import Script from 'next/script';

export function ZipScript() {
  const scriptUrl = process.env.NEXT_PUBLIC_ZIP_URL ?? '';

  return <Script src={scriptUrl} type='text/javascript'></Script>;
}
